export default __webpack_public_path__ + "static/media/combatactuator.563d2f4c.PNG";